// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   CircularProgress,
//   Alert,
//   Chip,
//   LinearProgress,
//   Avatar,
//   Divider,
// } from '@mui/material';
// import {
//   FlightTakeoff,
//   Pending,
//   AdminPanelSettings,
//   Person,
//   Email,
//   CalendarToday,
//   CheckCircle,
// } from '@mui/icons-material';
// import apiService from '../services/apiService';
// import socketService from '../services/socketService';

// // Component to display pilot enrollment status
// const PilotEnrollmentCard = ({ enrolledPilots, totalPilots, pendingVerifications }) => {
//   const percentage = totalPilots > 0 ? (enrolledPilots / totalPilots) * 100 : 0;
  
//   return (
//     <Card sx={{ 
//       height: '100%', 
//       background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//       boxShadow: 3,
//     }}>
//       <CardContent>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//           <Box>
//             <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }} gutterBottom>
//               Enrolled Pilots
//             </Typography>
//             <Typography variant="h3" fontWeight="bold" sx={{ color: '#fff', mb: 1 }}>
//               {enrolledPilots}
//             </Typography>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <Chip 
//                 icon={<FlightTakeoff sx={{ fontSize: 16 }} />} 
//                 label={`${totalPilots} Total`} 
//                 size="small" 
//                 sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff' }} 
//               />
//               <Chip 
//                 icon={<Pending sx={{ fontSize: 16 }} />} 
//                 label={`${pendingVerifications} Pending`} 
//                 size="small" 
//                 sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff' }} 
//               />
//             </Box>
//           </Box>
//           <Box
//             sx={{
//               bgcolor: 'rgba(255,255,255,0.2)',
//               p: 1.5,
//               borderRadius: 2,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}
//           >
//             <FlightTakeoff sx={{ fontSize: 40, color: '#fff' }} />
//           </Box>
//         </Box>
//         <Box sx={{ mt: 2 }}>
//           <LinearProgress 
//             variant="determinate" 
//             value={percentage} 
//             sx={{ 
//               height: 10, 
//               borderRadius: 5,
//               bgcolor: 'rgba(255,255,255,0.2)',
//               '& .MuiLinearProgress-bar': {
//                 bgcolor: '#fff',
//               }
//             }} 
//           />
//           <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)', mt: 0.5, display: 'block' }}>
//             {percentage.toFixed(1)}% enrollment rate
//           </Typography>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// // Component to display admin profile
// const AdminProfileCard = ({ admin }) => {
//   if (!admin) return null;

//   return (
//     <Card sx={{ height: '100%', boxShadow: 3 }}>
//       <CardContent>
//         <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//           <Avatar 
//             src={admin.profile_picture} 
//             sx={{ width: 56, height: 56, mr: 2, bgcolor: 'primary.main' }}
//           >
//             {admin.name?.charAt(0) || 'A'}
//           </Avatar>
//           <Box>
//             <Typography variant="h6" fontWeight="bold">
//               {admin.name || 'Admin'}
//             </Typography>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <AdminPanelSettings sx={{ fontSize: 16, color: 'primary.main' }} />
//               <Typography variant="caption" color="text.secondary">
//                 {admin.role || 'Super Admin'}
//               </Typography>
//               <Chip 
//                 size="small" 
//                 label={admin.status || 'Active'} 
//                 color="success"
//                 icon={<CheckCircle sx={{ fontSize: 14 }} />}
//                 sx={{ height: 20, '& .MuiChip-label': { fontSize: '0.7rem' } }}
//               />
//             </Box>
//           </Box>
//         </Box>

//         <Divider sx={{ my: 2 }} />

//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Person sx={{ fontSize: 18, color: 'text.secondary' }} />
//             <Typography variant="body2" color="text.secondary">
//               ID: {admin.id || 'N/A'}
//             </Typography>
//           </Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Email sx={{ fontSize: 18, color: 'text.secondary' }} />
//             <Typography variant="body2" color="text.secondary">
//               {admin.email || 'No email'}
//             </Typography>
//           </Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <CalendarToday sx={{ fontSize: 18, color: 'text.secondary' }} />
//             <Typography variant="body2" color="text.secondary">
//               Joined: {admin.created_at ? new Date(admin.created_at).toLocaleDateString() : 'N/A'}
//             </Typography>
//           </Box>
//           {admin.last_login && (
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <CalendarToday sx={{ fontSize: 18, color: 'text.secondary' }} />
//               <Typography variant="body2" color="text.secondary">
//                 Last Login: {new Date(admin.last_login).toLocaleString()}
//               </Typography>
//             </Box>
//           )}
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// const TaxiAttachmentDashboardPage = () => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [data, setData] = useState({
//     currentAdmin: null,
//     enrolledPilots: 0,
//   });
//   const [stats, setStats] = useState({
//     totalDrivers: 0,
//     enrolledPilots: 0,
//     pendingVerifications: 0,
//   });

//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         setLoading(true);
//         setError('');

//         // Check if token exists
//         const token = localStorage.getItem('adminToken');        
        
//         if (!token) {
//             setError('No authentication token found. Please login again.');
//             setLoading(false);
//             return;
//         }
        
//         // Fetch taxi attachment stats from the specific endpoint
//         // const response = await apiService.api.getTaxiAttachmentStats();
//         const response = await apiService.getTaxiAttachmentStats();

//         if (response.success) {
//           const { currentAdmin, enrolledPilots } = response.data;
          
//           setData({
//             currentAdmin,
//             enrolledPilots: enrolledPilots || 0,
//           });

//           setStats({
//             totalDrivers: enrolledPilots || 0, // Using enrolled pilots as total for now
//             enrolledPilots: enrolledPilots || 0,
//             pendingVerifications: 0, // You can add this from another endpoint
//           });
//         } else {
//           setError(response.message || 'Failed to load dashboard data');
//         }
//       } catch (err) {
//         console.error('Dashboard error:', err);
//         setError('Failed to load dashboard data. Please check if the backend server is running.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     // Socket listener for real-time updates
//     socketService.onDashboardUpdate((data) => {
//       if (data.enrolledPilots !== undefined) {
//         setStats((prev) => ({
//           ...prev,
//           enrolledPilots: data.enrolledPilots,
//           totalDrivers: data.enrolledPilots,
//         }));
//         setData((prev) => ({
//           ...prev,
//           enrolledPilots: data.enrolledPilots,
//         }));
//       }
//     });

//     loadData();

//     // Refresh data every 30 seconds
//     const refreshInterval = setInterval(loadData, 30000);

//     return () => {
//       clearInterval(refreshInterval);
//       socketService.off('admin:dashboard-update');
//     };
//   }, []);

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
//         <CircularProgress sx={{ color: 'primary.main' }} />
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Typography variant="h4" fontWeight="bold" gutterBottom>
//         Taxi Attachment Dashboard
//       </Typography>
//       <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//         Real-time overview of pilot enrollment and admin information
//       </Typography>

//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }}>
//           {error}
//         </Alert>
//       )}

//       <Grid container spacing={3}>
//         {/* Pilot Enrollment Card */}
//         <Grid item xs={12} md={6}>
//           <PilotEnrollmentCard 
//             enrolledPilots={stats.enrolledPilots}
//             totalPilots={stats.totalDrivers}
//             pendingVerifications={stats.pendingVerifications}
//           />
//         </Grid>

//         {/* Admin Profile Card */}
//         <Grid item xs={12} md={6}>
//           <AdminProfileCard admin={data.currentAdmin} />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// export default TaxiAttachmentDashboardPage;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Chip,
  LinearProgress,
  Avatar,
  Divider,
  Tooltip,
  IconButton,
  Button,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  FlightTakeoff,
  Pending,
  AdminPanelSettings,
  Person,
  Email,
  CalendarToday,
  CheckCircle,
  TrendingUp,
  TrendingDown,
  Refresh,
  Today,
  DateRange,
  MoreVert,
} from '@mui/icons-material';
import apiService from '../services/apiService';
import socketService from '../services/socketService';

// Time period metric card component
const TimePeriodMetricCard = ({ 
  title, 
  value, 
  subtitle, 
  percentageChange, 
  icon: Icon, 
  color = '#667eea',
  loading = false,
  period,
}) => {
  const isPositive = percentageChange >= 0;
  const changeColor = isPositive ? '#4caf50' : '#f44336';
  
  return (
    <Card sx={{ 
      height: '100%', 
      position: 'relative',
      transition: 'transform 0.2s, box-shadow 0.2s',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 6,
      },
      overflow: 'visible',
    }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Box>
            <Typography variant="caption" color="text.secondary" fontWeight="500">
              {title}
            </Typography>
            {loading ? (
              <CircularProgress size={24} sx={{ mt: 1 }} />
            ) : (
              <Typography variant="h4" fontWeight="bold" sx={{ my: 0.5 }}>
                {value}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              bgcolor: `${color}20`,
              p: 1,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon sx={{ color: color }} />
          </Box>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
          {percentageChange !== undefined && (
            <Chip
              icon={isPositive ? <TrendingUp sx={{ fontSize: 16 }} /> : <TrendingDown sx={{ fontSize: 16 }} />}
              label={`${isPositive ? '+' : ''}${percentageChange.toFixed(1)}%`}
              size="small"
              sx={{
                bgcolor: isPositive ? '#4caf5020' : '#f4433620',
                color: changeColor,
                fontWeight: 600,
                '& .MuiChip-icon': { color: changeColor },
              }}
            />
          )}
          <Typography variant="caption" color="text.secondary">
            {subtitle || period}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

// Component to display pilot enrollment status (kept from original)
const PilotEnrollmentCard = ({ enrolledPilots, totalPilots, pendingVerifications }) => {
  const percentage = totalPilots > 0 ? (enrolledPilots / totalPilots) * 100 : 0;
  
  return (
    <Card sx={{ 
      height: '100%', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      boxShadow: 3,
    }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }} gutterBottom>
              Enrolled Pilots
            </Typography>
            <Typography variant="h3" fontWeight="bold" sx={{ color: '#fff', mb: 1 }}>
              {enrolledPilots}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Chip 
                icon={<FlightTakeoff sx={{ fontSize: 16 }} />} 
                label={`${totalPilots} Total`} 
                size="small" 
                sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff' }} 
              />
              <Chip 
                icon={<Pending sx={{ fontSize: 16 }} />} 
                label={`${pendingVerifications} Pending`} 
                size="small" 
                sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff' }} 
              />
            </Box>
          </Box>
          <Box
            sx={{
              bgcolor: 'rgba(255,255,255,0.2)',
              p: 1.5,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <FlightTakeoff sx={{ fontSize: 40, color: '#fff' }} />
          </Box>
        </Box>
        <Box sx={{ mt: 2 }}>
          <LinearProgress 
            variant="determinate" 
            value={percentage} 
            sx={{ 
              height: 10, 
              borderRadius: 5,
              bgcolor: 'rgba(255,255,255,0.2)',
              '& .MuiLinearProgress-bar': {
                bgcolor: '#fff',
              }
            }} 
          />
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.8)', mt: 0.5, display: 'block' }}>
            {percentage.toFixed(1)}% enrollment rate
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

// Component to display admin profile (kept from original)
const AdminProfileCard = ({ admin }) => {
  if (!admin) return null;

  return (
    <Card sx={{ height: '100%', boxShadow: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Avatar 
            src={admin.profile_picture} 
            sx={{ width: 56, height: 56, mr: 2, bgcolor: 'primary.main' }}
          >
            {admin.name?.charAt(0) || 'A'}
          </Avatar>
          <Box>
            <Typography variant="h6" fontWeight="bold">
              {admin.name || 'Admin'}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AdminPanelSettings sx={{ fontSize: 16, color: 'primary.main' }} />
              <Typography variant="caption" color="text.secondary">
                {admin.role || 'Super Admin'}
              </Typography>
              <Chip 
                size="small" 
                label={admin.status || 'Active'} 
                color="success"
                icon={<CheckCircle sx={{ fontSize: 14 }} />}
                sx={{ height: 20, '& .MuiChip-label': { fontSize: '0.7rem' } }}
              />
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Person sx={{ fontSize: 18, color: 'text.secondary' }} />
            <Typography variant="body2" color="text.secondary">
              ID: {admin.id || 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Email sx={{ fontSize: 18, color: 'text.secondary' }} />
            <Typography variant="body2" color="text.secondary">
              {admin.email || 'No email'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalendarToday sx={{ fontSize: 18, color: 'text.secondary' }} />
            <Typography variant="body2" color="text.secondary">
              Joined: {admin.created_at ? new Date(admin.created_at).toLocaleDateString() : 'N/A'}
            </Typography>
          </Box>
          {admin.last_login && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CalendarToday sx={{ fontSize: 18, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                Last Login: {new Date(admin.last_login).toLocaleString()}
              </Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

// New component for additional details per time period
const PeriodDetailCard = ({ period, data }) => {
  return (
    <Card sx={{ height: '100%', boxShadow: 1 }}>
      <CardContent>
        <Typography variant="caption" color="text.secondary" fontWeight="500">
          {period} Details
        </Typography>
        <Box sx={{ mt: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
            <Typography variant="body2" color="text.secondary">New Enrollments</Typography>
            <Typography variant="body2" fontWeight="600">{data?.newEnrollments || 0}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
            <Typography variant="body2" color="text.secondary">Verifications</Typography>
            <Typography variant="body2" fontWeight="600">{data?.verifications || 0}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
            <Typography variant="body2" color="text.secondary">Active Pilots</Typography>
            <Typography variant="body2" fontWeight="600">{data?.activePilots || 0}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

const TaxiAttachmentDashboardPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState({
    currentAdmin: null,
    enrolledPilots: 0,
  });
  const [stats, setStats] = useState({
    totalDrivers: 0,
    enrolledPilots: 0,
    pendingVerifications: 0,
  });
  
  // New state for time-based metrics
  const [timeMetrics, setTimeMetrics] = useState({
    today: { count: 0, change: 0, details: {} },
    yesterday: { count: 0, change: 0, details: {} },
    last7Days: { count: 0, change: 0, details: {} },
    last30Days: { count: 0, change: 0, details: {} },
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState('all');

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (period) => {
    if (period) {
      setSelectedPeriod(period);
    }
    setAnchorEl(null);
  };

  // Fetch time-based metrics
  const fetchTimeMetrics = async () => {
    try {
      const response = await apiService.getTimeMetrics(); // You'll need to implement this endpoint
      if (response.success) {
        setTimeMetrics(response.data);
      }
    } catch (err) {
      console.error('Error fetching time metrics:', err);
      // Fallback to mock data if endpoint doesn't exist yet
      setTimeMetrics({
        today: { 
          count: 12, 
          change: 8.5, 
          details: { newEnrollments: 5, verifications: 3, activePilots: 12 } 
        },
        yesterday: { 
          count: 8, 
          change: -2.3, 
          details: { newEnrollments: 3, verifications: 2, activePilots: 8 } 
        },
        last7Days: { 
          count: 45, 
          change: 12.7, 
          details: { newEnrollments: 18, verifications: 12, activePilots: 45 } 
        },
        last30Days: { 
          count: 156, 
          change: 25.3, 
          details: { newEnrollments: 62, verifications: 41, activePilots: 156 } 
        },
      });
    }
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError('');

        // Check if token exists
        const token = localStorage.getItem('adminToken');        
        if (!token) {
          setError('No authentication token found. Please login again.');
          setLoading(false);
          return;
        }
        
        // Fetch taxi attachment stats
        const response = await apiService.getTaxiAttachmentStats();
        
        if (response.success) {
          const { currentAdmin, enrolledPilots } = response.data;
          setData({
            currentAdmin,
            enrolledPilots: enrolledPilots || 0,
          });
          setStats({
            totalDrivers: enrolledPilots || 0,
            enrolledPilots: enrolledPilots || 0,
            pendingVerifications: 0,
          });
        } else {
          setError(response.message || 'Failed to load dashboard data');
        }

        // Fetch time metrics
        await fetchTimeMetrics();
      } catch (err) {
        console.error('Dashboard error:', err);
        setError('Failed to load dashboard data. Please check if the backend server is running.');
        // Still try to load time metrics with fallback
        await fetchTimeMetrics();
      } finally {
        setLoading(false);
      }
    };

    // Socket listener for real-time updates
    socketService.onDashboardUpdate((data) => {
      if (data.enrolledPilots !== undefined) {
        setStats((prev) => ({
          ...prev,
          enrolledPilots: data.enrolledPilots,
          totalDrivers: data.enrolledPilots,
        }));
        setData((prev) => ({
          ...prev,
          enrolledPilots: data.enrolledPilots,
        }));
      }
      // Refresh time metrics on update
      fetchTimeMetrics();
    });

    loadData();

    // Refresh data every 30 seconds
    const refreshInterval = setInterval(() => {
      loadData();
      fetchTimeMetrics();
    }, 30000);

    return () => {
      clearInterval(refreshInterval);
      socketService.off('admin:dashboard-update');
    };
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
        <CircularProgress sx={{ color: 'primary.main' }} />
      </Box>
    );
  }

  // Define time period cards configuration
  const timePeriodCards = [
    {
      id: 'today',
      title: 'Today',
      value: timeMetrics.today.count,
      subtitle: 'New enrollments today',
      percentageChange: timeMetrics.today.change,
      icon: Today,
      color: '#4CAF50',
    },
    {
      id: 'yesterday',
      title: 'Yesterday',
      value: timeMetrics.yesterday.count,
      subtitle: 'New enrollments yesterday',
      percentageChange: timeMetrics.yesterday.change,
      icon: CalendarToday,
      color: '#FF9800',
    },
    {
      id: 'last7Days',
      title: 'Last 7 Days',
      value: timeMetrics.last7Days.count,
      subtitle: 'Enrollments in last week',
      percentageChange: timeMetrics.last7Days.change,
      icon: DateRange,
      color: '#2196F3',
    },
    {
      id: 'last30Days',
      title: 'Last 30 Days',
      value: timeMetrics.last30Days.count,
      subtitle: 'Enrollments in last month',
      percentageChange: timeMetrics.last30Days.change,
      icon: DateRange,
      color: '#9C27B0',
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Taxi Attachment Dashboard
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Real-time overview of pilot enrollment and admin information
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Tooltip title="Refresh data">
            <IconButton 
              onClick={() => { 
                loadData(); 
                fetchTimeMetrics(); 
              }} 
              disabled={loading}
            >
              <Refresh />
            </IconButton>
          </Tooltip>
          <Button
            variant="outlined"
            size="small"
            endIcon={<MoreVert />}
            onClick={handleMenuOpen}
          >
            {selectedPeriod === 'all' ? 'All Periods' : selectedPeriod}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleMenuClose()}
          >
            <MenuItem onClick={() => handleMenuClose('all')}>All Periods</MenuItem>
            <MenuItem onClick={() => handleMenuClose('today')}>Today</MenuItem>
            <MenuItem onClick={() => handleMenuClose('yesterday')}>Yesterday</MenuItem>
            <MenuItem onClick={() => handleMenuClose('last7Days')}>Last 7 Days</MenuItem>
            <MenuItem onClick={() => handleMenuClose('last30Days')}>Last 30 Days</MenuItem>
          </Menu>
        </Box>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {/* Time Period Metric Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        {timePeriodCards.map((card) => (
          <Grid item xs={12} sm={6} md={3} key={card.id}>
            <TimePeriodMetricCard
              title={card.title}
              value={card.value}
              subtitle={card.subtitle}
              percentageChange={card.percentageChange}
              icon={card.icon}
              color={card.color}
              period={card.id}
            />
          </Grid>
        ))}
      </Grid>

      {/* Period Details and Main Cards */}
      <Grid container spacing={3}>
        {/* Period Details */}
        {selectedPeriod !== 'all' && (
          <Grid item xs={12} md={4}>
            <PeriodDetailCard 
              period={selectedPeriod} 
              data={timeMetrics[selectedPeriod]?.details} 
            />
          </Grid>
        )}

        {/* Pilot Enrollment Card */}
        <Grid item xs={12} md={selectedPeriod !== 'all' ? 4 : 6}>
          <PilotEnrollmentCard 
            enrolledPilots={stats.enrolledPilots}
            totalPilots={stats.totalDrivers}
            pendingVerifications={stats.pendingVerifications}
          />
        </Grid>

        {/* Admin Profile Card */}
        <Grid item xs={12} md={selectedPeriod !== 'all' ? 4 : 6}>
          <AdminProfileCard admin={data.currentAdmin} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TaxiAttachmentDashboardPage;